<template>
  <li
    class="lp-dropdown-item ly-spacebetween-center"
    :class="[
      disabled && 'lp-dropdown-item-disabled',
      divided && 'lp-dropdown-item-divided',
    ]"
    v-on="listeners"
  >
    <component :is="wrapper" v-bind="wrapperProps">
      <lp-icon v-if="icon" :name="icon" class="xmr-2" />
      <span class="lp-dropdown-text">
        <slot />
      </span>
    </component>
    <slot name="submenu" />
  </li>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'
import { DropdownItemProps } from './LpDropdownTypes'

type ParentToggleDropdown = () => void

defineOptions({
  name: 'lp-dropdown-item',
})

const props = withDefaults(defineProps<DropdownItemProps>(), {
  disabled: false,
  divided: false,
  icon: null,
  withWrapper: true,
  wrapperTag: 'a',
  wrapperProps: null,
})

const emit = defineEmits(['toggle-dropdown'])

const listeners = computed(() => {
  return props.disabled
    ? {}
    : {
        click: toggleDropdown,
      }
})

const parentToggleDropdown: ParentToggleDropdown | unknown = inject(
  'toggleDropdown',
  () => {
    return
  },
)

const toggleDropdown = (e: MouseEvent) => {
  e.stopPropagation()
  emit('toggle-dropdown')
  if (parentToggleDropdown && typeof parentToggleDropdown === 'function') {
    parentToggleDropdown(e, true)
  }
}

const wrapper = computed(() => {
  return props.withWrapper ? props.wrapperTag : 'lp-fragment'
})
</script>
